import animationStyles from './styles/product.videoAnimation.module.scss';
import React from 'react';
import { clsx } from '../../../../utils/clsx';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
import { getSrcSetForLazy } from '../../../../utils/getSrcSetForLazy';
import { ppData } from '../../configs/ppData.config';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { FlatPreview } from './FlatPreview';
import { SuspenseImage } from '../../../../Components/react/SuspenseImage';
import { layoutValues } from '../../configs/options';
const isVertical = layoutValues[0][0].shape.includes('vertical');
const thumbnailAlts = [
    'Wall Art',
    'Art',
    'Wall Decor',
    'Wall Art Pictures',
    'Wall Art Decor'
];
const thumbnailsStyles = MEDIA_BREAKPOINTS.LG_UP.matches
    ? 'pos:a z:1 t:0 l:0 h:100p w:1/8 gtr:6 gap:8 gap:16:xl-up pr:4:xl-up'
    : MEDIA_BREAKPOINTS.MD_UP.matches
        ? 'pos:a z:1 t:0 l:0 h:100p gap:16 w:128 gaf:row gar:1fr scrbar:none ov:x:h ov:y:a'
        : 'w:100vw mx:-pw px:pw py:12 gaf:column gap:12 gac:1/5 scrbar:none ov:x:a ov:y:h';
const BasicImage = ({ src, index }) => (React.createElement(SuspenseImage, { className: "image:cover z:-1", sizes: "(min-width: 93.75) 5.4375rem, (min-width: 75rem) calc(5.7805vw - 0.125rem), (min-width: 64rem) calc(5.1339vw - 0.125rem), (min-width: 48rem) 16.6666vw, calc(20vw - 0.35rem)", srcSet: getSrcSetForLazy(src, 540), src: src, alt: `${ppData.title} ${thumbnailAlts[index]}`, height: 114, width: 114 }));
export const Thumbnails = ({ images, activeImgIndex, clickHandler }) => {
    return (React.createElement("ul", { className: `list:none lh:0 d:grid ${thumbnailsStyles}` }, images.map((image, i) => {
        const isActive = activeImgIndex === i;
        return (React.createElement("li", { key: i, className: "bg:f4f4f4" },
            React.createElement("button", { className: clsx('pos:r z:1 btn:cleared w:100p image-wrapper bdrs:1 trs ov:h ol ol:o:-1', isActive ? 'ol:c:text ol:w:1' : 'ol:c:text-light hover:ol:w:1', (!MEDIA_BREAKPOINTS.MD_UP.matches || MEDIA_BREAKPOINTS.XL_UP.matches) && (isActive ? 'bxsh:3' : 'hover:bxsh:3')), onClick: () => { clickHandler(i); } },
                typeof image === 'string'
                    ? React.createElement(BasicImage, { src: image, index: i })
                    : React.createElement(FlatPreview, { data: image, srcSetMaxSize: 540, imageAlt: `${ppData.title} ${thumbnailAlts[i]}`, className: "z:-1 pos:a t:0 l:0 h:100p w:100p" }),
                !ppData.isPersonalized && !isVertical && i === 4 &&
                    React.createElement(Ssvg, { icon: "#icon--video-play", className: clsx('pos:a z:2 t:50p l:50p trf:t:-50p', animationStyles.thumbnailPlayIcon) }))));
    })));
};
